import React from "react";
import "./Navbar.css";
import logoImage from "../images/logo.jpg";
import ukimage from "../images/uk.png";
import spainImage from "../images/spain.png";
import geoImage from "../images/georgia.png";
import Modal from "react-modal";
import en from "../data/en";
import es from "../data/es";
import geo from "../data/geo";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Navbar = ({ language, onClick }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const imageClickHandle = () => {
    window.scrollTo({ top: "0" });
  };

  return (
    <div className="navbar-fixed">
      <div className="navbar">
        <div className="navbar-logo" onClick={imageClickHandle}>
          <img src={logoImage} alt="logoImage" />
        </div>
        <div className="navbar-content">
          <div className="navbar-links">
            <a href="#home" className="navbar-link">
              {language.home}
            </a>
            <a href="#services" className="navbar-link">
              {language.services}
            </a>
            <a href="#aboutme" className="navbar-link">
              {language.aboutMe}
            </a>
            <a href="#contact" className="navbar-link">
              {language.contact}
            </a>
            <div className="navbar-link" onClick={openModal}>
              {language.lang == "en" && (
                <img height="30px" src={ukimage} alt="ukimage" />
              )}
              {language.lang == "es" && (
                <img height="30px" src={spainImage} alt="spainimage" />
              )}
              {language.lang == "geo" && (
                <img height="30px" src={geoImage} alt="geoImage" />
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h1
          style={{
            color: "#000",
          }}
        >
          Select Language
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            height: "100px",
          }}
        >
          <img
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              onClick(en);
              closeModal();
            }}
            height="50px"
            src={ukimage}
            alt="ukimage"
          />
          <img
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              onClick(es);
              closeModal();
            }}
            height="50px"
            src={spainImage}
            alt="spainimage"
          />
          <img
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              onClick(geo);
              closeModal();
            }}
            height="50px"
            src={geoImage}
            alt="geoImage"
          />
        </div>
      </Modal>
    </div>
  );
};

export default Navbar;
